// import _ from 'lodash'
import axios from 'axios'

const state = {
    favorites: [],
}
const mutations = {
    loadFavorites (state, favorites) {
        state.favorites = favorites
    },
    addFavorite (state, favorite) {
        state.favorites.push(favorite)
    },
    deleteFavorite (state, favoriteId) {
        state.favorites = state.favorites.filter(favorite => favorite.id !== parseInt(favoriteId, 10))
    },

}
const getters = {
        getFavorite: (state)  => (activity_id) => {
        return state.favorites.find(c => c.activity === parseInt(activity_id, 10))
    }

}
export const actions = {

    async loadFavorites ({ commit }) {
        const response = await axios.get(`${window.selfcareConfig.baseURL}/en/selfcare/favorites`, { withCredentials: true })
        commit('loadFavorites', response.data)
    },

    async addFavorite ({ commit }, favorite) {
        const response = await axios.post(`${window.selfcareConfig.baseURL}/en/selfcare/favorites`, favorite, { withCredentials: true })
        commit('addFavorite', response.data)
    },
    async deleteFavorite ({ commit }, favorite ) {
        await axios.delete(`${window.selfcareConfig.baseURL}/en/selfcare/favorites/${favorite.id}`, favorite.id, { withCredentials: true })
        commit('deleteFavorite', favorite.id)
    },
}

export default {
    state,
    mutations,
    getters,
    actions,
}